import { render, staticRenderFns } from "./AllotUser.vue?vue&type=template&id=1e99f13a&scoped=true"
import script from "./AllotUser.vue?vue&type=script&lang=js"
export * from "./AllotUser.vue?vue&type=script&lang=js"
import style0 from "./AllotUser.vue?vue&type=style&index=0&id=1e99f13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99f13a",
  null
  
)

export default component.exports